/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropKickVodResponse } from './DropKickVodResponse';
import {
    DropKickVodResponseFromJSON,
    DropKickVodResponseFromJSONTyped,
    DropKickVodResponseToJSON,
    DropKickVodResponseToJSONTyped,
} from './DropKickVodResponse';

/**
 * 
 * @export
 * @interface DropKickVodsResponse
 */
export interface DropKickVodsResponse {
    /**
     * 
     * @type {string}
     * @memberof DropKickVodsResponse
     */
    channelSlug: string | null;
    /**
     * 
     * @type {Array<DropKickVodResponse>}
     * @memberof DropKickVodsResponse
     */
    vods: Array<DropKickVodResponse>;
    /**
     * 
     * @type {number}
     * @memberof DropKickVodsResponse
     */
    computedAt: number;
}

/**
 * Check if a given object implements the DropKickVodsResponse interface.
 */
export function instanceOfDropKickVodsResponse(value: object): value is DropKickVodsResponse {
    if (!('channelSlug' in value) || value['channelSlug'] === undefined) return false;
    if (!('vods' in value) || value['vods'] === undefined) return false;
    if (!('computedAt' in value) || value['computedAt'] === undefined) return false;
    return true;
}

export function DropKickVodsResponseFromJSON(json: any): DropKickVodsResponse {
    return DropKickVodsResponseFromJSONTyped(json, false);
}

export function DropKickVodsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropKickVodsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'channelSlug': json['channelSlug'],
        'vods': ((json['vods'] as Array<any>).map(DropKickVodResponseFromJSON)),
        'computedAt': json['computedAt'],
    };
}

export function DropKickVodsResponseToJSON(json: any): DropKickVodsResponse {
    return DropKickVodsResponseToJSONTyped(json, false);
}

export function DropKickVodsResponseToJSONTyped(value?: DropKickVodsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'channelSlug': value['channelSlug'],
        'vods': ((value['vods'] as Array<any>).map(DropKickVodResponseToJSON)),
        'computedAt': value['computedAt'],
    };
}

